module.exports = __webpack_public_path__ + "img/59400.e283ef64.jpg";